import React, { PureComponent } from 'react';
import adg from '../../../commonbase/adg';
import PathBuilder from '../svg/PathBuilder';
import OpacityHelper from './OpacityHelper';

export default class AddColumnIcon extends PureComponent {

  constructor(props) {
    super(props);
    this.opacityHelper = new OpacityHelper(this);
  }

  render() {
    const width = this.props.width;
    const height = this.props.height;
    const plusTop = height / 6;
    const plusBottom = plusTop + height / 2;
    const plusLeft = width / 4;
    const plusRight = width - plusLeft;
    const plusMiddle = (plusLeft + plusRight) / 2;
    const plusMiddleY = (plusTop + plusBottom) / 2;
    const triangleTop = height / 2;
    const mainFill = new PathBuilder('main-fill')
      .setPathColor(adg.adgGreen)
      .setFill(adg.adgGreen)
      .setPathWidth(2)
      .moveTo(0, 0)
      .lineTo(0, triangleTop)
      .lineTo(width / 2, height)
      .lineTo(width, triangleTop)
      .lineTo(width, 0)
      .lineTo(0, 0)
      .close()
      .render();
    const plusLine1 = new PathBuilder('line-a')
      .setPathColor('#fff')
      .setPathWidth(2)
      .moveTo(plusMiddle, plusTop)
      .lineTo(plusMiddle, plusBottom)
      .render();
    const plusLine2 = new PathBuilder('line-b')
      .setPathColor('#fff')
      .setPathWidth(2)
      .moveTo(plusLeft, plusMiddleY)
      .lineTo(plusRight, plusMiddleY)
      .render();
    return (
      <svg
        style={this.opacityHelper.buildStyle()}
        width={width}
        height={height}
        onMouseEnter={this.opacityHelper.onMouseEnter}
        onMouseLeave={this.opacityHelper.onMouseLeave}
        onClick={this.props.onClick}
      >
        {mainFill}
        {plusLine1}
        {plusLine2}
      </svg>
    );
  }

}